import React from 'react';
import { Header } from 'layout';
import { UserTransactionsTable } from 'modules';
import { useGetEtzProfileTransactions } from 'hooks/api/portfolio';
import EtzProfileNavTabs from '../components/EtzProfileNavTabs';
import EtzProfileBalance from '../components/EtzProfileBalance';

import messages from './EtzProfileTransactions.messages';

const EtzProfileTransactions: React.FC = () => {
  const {
    data: transactionsData,
    isLoading: portfolioTransactionsLoading,
    isError,
    refetch,
    isRefetching,
  } = useGetEtzProfileTransactions();

  return (
    <>
      <Header title={messages.headerTitle} />
      <EtzProfileNavTabs />
      <EtzProfileBalance />
      <UserTransactionsTable
        columns={[
          'assetName',
          'type',
          'orderStatus',
          'date',
          'usdAmount',
          'assetAmount',
          'chargedFrom',
        ]}
        transactionsData={transactionsData}
        portfolioTransactionsLoading={portfolioTransactionsLoading}
        isError={isError}
        isRefetching={isRefetching}
        refetch={refetch}
      />
    </>
  );
};

export default EtzProfileTransactions;
